export const api = {
  instructorUtilization: "class_utilization",
  instructorClosingConversion: "closing_conversion",
  firstVisitConversions: "first_visit_conversions"
};
